/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import {
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge,
  SectionHeadingSmall,
  SectionInnerHeading
} from '../../../Components/Headings';
import './dashboard.css';
import { SimpleCard } from '../../../Components/Card';
import Comments from './comments/Comments';
import Reviws from './reviws/Reviws';

const quickSummary = [
  { title: 'Total Appointments', number: '12' },
  { title: 'In person Appointments', number: '10' },
  { title: 'Virtual Appointments', number: '2' },
  { title: 'Instant Consultation', number: '4' },
  { title: 'Total Comments', number: '145' },
  { title: 'Total Doctor Reviews Given', number: '55' },
  { title: 'HealthCheck', number: '6' },
  { title: 'Total Medical Record', number: '34' },
  { title: 'Family Members Added', number: '3' }
];

function Dashboard() {
  return (
    <HealthCheckLayout>
      <section className="dashboard bgLinghtGray">
        <Container>
          <div className="mb-3">
            <HeadingWithSpaceLarge text="DASHBOARD" />
            <SectionHeadingSmall text="Hello Alyna! Here’s a quick summary for you." />
          </div>
          <Row>
            <Col md={9}>
              <div className="quickSummaryContainer">
                {quickSummary.map((summary, index) => {
                  const { title, number } = summary;
                  return (
                    <div key={index} className="quickSummaryBox">
                      <SimpleCard>
                        <HeadingDescSmall text={title} />
                        <h3>{number}</h3>
                      </SimpleCard>
                    </div>
                  );
                })}
              </div>
            </Col>
            <Col md={3}>
              <div className="subscriptionInfo">
                <HeadingWithSpaceLarge text="SUBSCRIPTION" />
                <SectionInnerHeading text="Basic" />
                <h3>Rs. 500</h3>
                <HeadingDescSmall text="Monthly" />
                <HeadingDescVsmall text="*Expires on April 15, 2021" />
              </div>
            </Col>
            <Col md={6}>
              <Comments />
            </Col>
            <Col md={6}>
              <Reviws />
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default Dashboard;
